import EquipmentShopItem from './EquipmentShopItem';

export default EquipmentShopItem;
export { EquipmentShopItem };
